export default __webpack_public_path__ + "static/media/pattern-lines.ba7ee10a.svg";